// ============================================================
// NETWORK CONFIG — 3-contract split architecture
// ============================================================
// Set ACTIVE_NETWORK to one of: "mainnet" | "testnet" | "opbnb"
//   mainnet  = BSC mainnet (production)
//   testnet  = BSC testnet
//   opbnb    = opBNB testnet (extra testing environment)
// Users never see which one is active.
//
// The contract is deployed as THREE pieces per network:
//   storageAddress   — persistent state, admin/wallet management, migration.
//                      Users approve USDT here.
//   logicAddress     — business logic (register / activate / claim / block / etc.).
//                      Stateless. Must be linked via Storage.setLogicContract().
//   migratorAddress  — (optional) batch import helper. Only needed during migration
//                      from a legacy deployment. Set to zero-address if unused.
// ============================================================

export const ACTIVE_NETWORK = "mainnet"; // "mainnet" | "testnet" | "opbnb"

const ZERO = "0x0000000000000000000000000000000000000000";

const NETWORKS = {
  mainnet: {
    chainId: 56,
    chainIdHex: "0x38",
    chainName: "BNB Smart Chain",
    nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
    rpcUrls: [
      "https://bsc-dataseed.binance.org",
      "https://bsc-dataseed1.defibit.io",
      "https://bsc-dataseed1.ninicoin.io",
      "https://bsc.publicnode.com",
    ],
    blockExplorerUrls: ["https://bscscan.com"],
    // BSC-USD (Binance-Peg USDT) — 18 decimals on BSC
    usdtAddress: "0x55d398326f99059ff775485246999027b3197955",
    storageAddress: "0xB2d3dBe360b4ECA26301636610A2EB989c00c066",
    logicAddress:   "0x5BB846A452f09c533f9Ff2B39907c2C5328de00d",
    migratorAddress: "0x4f1F555f1F173A5bAd4679c3Fd65cB081c6e34bd",
  },
  testnet: {
    chainId: 97,
    chainIdHex: "0x61",
    chainName: "BNB Smart Chain Testnet",
    nativeCurrency: { name: "tBNB", symbol: "tBNB", decimals: 18 },
    rpcUrls: [
      "https://data-seed-prebsc-1-s1.binance.org:8545",
      "https://data-seed-prebsc-2-s1.binance.org:8545",
      "https://bsc-testnet.publicnode.com",
    ],
    blockExplorerUrls: ["https://testnet.bscscan.com"],
    usdtAddress: "0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC",
    storageAddress: "0x15dAF6cb421aBC6f4F05E260a54Dd82F130365c0",
    logicAddress:   "0xEF9Ff25874A3BA7F53eFf0853c301E20386436EC",
    migratorAddress: "0x0ecd858361A515fE1563772b99EB5e530E3F7881",
  },
  opbnb: {
    chainId: 5611,
    chainIdHex: "0x15eb",
    chainName: "opBNB Testnet",
    nativeCurrency: { name: "tBNB", symbol: "tBNB", decimals: 18 },
    rpcUrls: ["https://opbnb-testnet-rpc.bnbchain.org"],
    blockExplorerUrls: ["https://opbnb-testnet.bscscan.com"],
    usdtAddress: "0xBf6596a279172D330b8b732D257Ee633B6FDA911",
    storageAddress: "0xc4A3EfF92F83290C25dba3A80C9cd1389C3e68a3",
    logicAddress:   ZERO, // TODO: opbnb Logic
    migratorAddress: ZERO, // TODO: opbnb Migrator (optional)
  },
};

export const CURRENT_NETWORK = NETWORKS[ACTIVE_NETWORK];

// Public-facing chain name — hides which network is active.
export const getNetworkName = () => "BSC";
